// The first visible title is 40px below the mobile header border and 80px below the desktop logo ink.
export const firstContentSpacing = 'pt-10 lg:pt-[63px] 2xl:pt-[31px]';
